import {Component, OnInit} from '@angular/core';

import {LiChessService} from "./li-chess.service";
import {Player} from '../chess/player';
import {LiChessPlayer} from "./li-chess-player";

@Component({
  selector: 'app-li-chess-player',
  templateUrl: './li-chess-player.component.html',
  styleUrls: ['./li-chess-player.component.sass']
})
export class LiChessPlayerComponent implements OnInit {
  player: LiChessPlayer;
  error: any;

  constructor(private service: LiChessService) {
  }

  ngOnInit() {
    console.log("LiChessPlayerComponent ngOnInit");
    // FIXME error handling
    this.service.getProfile('ruttuvaari')
      .then(player => {
        this.player = player;
      })
      .catch(error => this.error = error);
  }
}



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/profile/li-chess-player.component.ts